import { apiSlice } from "../../api-slice";
import { TransferProposalBody } from "./transfer-ownership-request";
import { AllProposalOfUserData, DefaultTransferOwnershipProposalResponse, GetAllProposalOfUserResponse, GMSUsersData, GMSUsersResponse } from "./transfer-ownership-response";

export interface GetProposalOwnersParams {
    page?: number;
    per_page?: number;
    status?: string;
    email?: string;
    group_name?: string;
    product?: string;
    preparedBy?: string;
    userId: number;
}
export type SearchFieldProposalOwnership = "group_name" | "email" | "product" | "preparedBy" | "status";
// http://localhost:5000/api/financial-insurance/gms-department
// http://localhost:5000/api/user/admin/transfer-ownership
export const transferOwnership = apiSlice.injectEndpoints({
    endpoints: builder => ({
        // http://localhost:5000/api/user/admin/transfer-ownership/34/applications?page=1&per_page=10
        getProposalOfUser: builder.query<AllProposalOfUserData, GetProposalOwnersParams>({
            query: ({ userId, ...params }) => ({
                url: `/api/user/admin/transfer-ownership/${userId}/applications`,
                params,
            }),
            transformResponse: (response: GetAllProposalOfUserResponse) => response.data,
            transformErrorResponse: (response: any) => response.data,
        }),
        getUsersOfGMS: builder.query<GMSUsersData, void>({
            query: () => ({
                url: `/api/financial-insurance/gms-department`,
            }),
            transformResponse: (response: GMSUsersResponse) => response.data,
            transformErrorResponse: (response: any) => response.data,
        }),
        // http://localhost:5000/api/user/admin/transfer-ownership
        transferOwnershipProposal: builder.mutation<DefaultTransferOwnershipProposalResponse, TransferProposalBody>({
            query: (body) => ({
                url: `/api/user/admin/transfer-ownership`,
                method: 'POST',
                body,
            }),
            transformErrorResponse: (response: any) => response.data,
            invalidatesTags: [
                { type: 'Proposal', id: 'LIST' },
                { type: 'RequestExistingGroup', id: 'LIST' },
            ],
        }),
    })
})

export const {
    useGetProposalOfUserQuery,
    useGetUsersOfGMSQuery,
    useTransferOwnershipProposalMutation,
} = transferOwnership; 